"use strict";

/**
 * A module to handle the alerts of the forms.
 * Requires the a unique class name to be placed at the formStatus component.
 * Use that class as the `extraClass` parameter at the
 * login.components.form-submission-status.form-submission-status component.
 *
 * suggested class name format: "js-my-unique-description-form-status".
 *
 * exports:
 *  - showSuccess: shows a success state message.
 *  - showError: Shows an error state message.
 *  - clearStatus: clear the status element.
 *
 */

const $ = require("jquery");

/**
 *
 * @param {string} alertWindowClass The class of the specific container element
 * @param {string} message The message to show
 * @param {string} status The "success" or "error"  state
 * @param {boolean} scrollIntoView If true, the page will scroll into view
 *
 */
function showMessage(
  alertWindowClass,
  message,
  status,
  scrollIntoView,
  toLast
) {
  const statutsClass = status === "success" ? "alert-success" : "alert-danger";
  const variant = status === "success" ? "success" : "error";

  const elementClass = alertWindowClass + "--" + variant;
  const messageElement = $("." + elementClass);

  const hasMessages = $(messageElement).find(".alert").length > 0;
  if (hasMessages) {
    let messageHTML = "";
    messageHTML += '<p class="js-alert mb-0">';
    messageHTML += message;
    messageHTML += "</p>";
    $(messageElement)
      .find("." + statutsClass)
      .append(messageHTML);
  } else {
    let messageHTML = "";
    messageHTML +=
      '<div class="col-md-12 alert ' +
      statutsClass +
      ' form-status__item" role="alert">';
    messageHTML += '<p class="js-alert mb-0">';
    messageHTML += message;
    messageHTML += "</p>";
    messageHTML += "</div>";

    $(messageElement).html(messageHTML);
  }

  if (scrollIntoView) {
    if (toLast) {
      $("." + elementClass).length > 0 &&
        $("." + elementClass)
          .first()
          .parent()
          .get(0)
          .scrollIntoView();
    } else {
      $("." + elementClass).length > 0 &&
        $("." + elementClass)
          .last()
          .parent()
          .get(0)
          .scrollIntoView();
    }
  }
}

// Shows the message as error state
function showError(
  alertWindowClass,
  message,
  scrollIntoView = true,
  toLast = false
) {
  showMessage(alertWindowClass, message, "danger", scrollIntoView);
}

// Shows the message as success state
function showSuccess(
  alertWindowClass,
  message,
  scrollIntoView = true,
  toLast = false
) {
  showMessage(alertWindowClass, message, "success", scrollIntoView);
}

// Clears the status messages.
function clearStatus(alertWindowClass) {
  const successClass = alertWindowClass + "--success";
  const errorClass = alertWindowClass + "--error";

  const successElement = $("." + successClass);
  const errorElement = $("." + errorClass);

  $(successElement).html("");
  $(errorElement).html("");
}

module.exports = {
  showError,
  showSuccess,
  clearStatus
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-form-status/booking-form-status.js